import { Injectable, inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class TokenStorageService {
  private platformId = inject(PLATFORM_ID);

  private accessKey = 'swipfx_access_token';
  private refreshKey = 'swipfx_refresh_token';
  private tokenTypeKey = 'swipfx_token_type';
  private accessExpKey = 'swipfx_access_expires_at';
  private refreshExpKey = 'swipfx_refresh_expires_at';
  private tempTokenKey = "swipfx_refresh_temp_token";
  private totpChallengeKey = "swipfx_totp_challenge_token";

  private get storage(): Storage | null {
    return isPlatformBrowser(this.platformId) ? localStorage : null;
  }

  getAccessToken(): string | null {
    return this.storage?.getItem(this.accessKey) ?? null;
  }

  getTempToken(): string | null {
    return this.storage?.getItem(this.tempTokenKey) ?? null;
  }

  getTotpChallengeToken(): string | null {
    return this.storage?.getItem(this.totpChallengeKey) ?? null;
  }

  getRefreshToken(): string | null {
    return this.storage?.getItem(this.refreshKey) ?? null;
  }

  getTokenType(): string | null {
    return this.storage?.getItem(this.tokenTypeKey) ?? null;
  }

  setTempToken(token: string): void {
    this.storage?.setItem(this.tempTokenKey, token);
  }

  clearTempToken() {
    this.storage?.removeItem(this.tempTokenKey);
  }

  setTotpChallengeToken(token: string): void {
    this.storage?.setItem(this.totpChallengeKey, token);
  }

  clearTotpChallengeToken() {
    this.storage?.removeItem(this.totpChallengeKey);
  }

  setTokens(t: {
    accessToken: string;
    refreshToken: string;
    tokenType?: string;
    expiresAt?: string;
    refreshTokenExpiresAt?: string;
  }) {
    this.storage?.setItem(this.accessKey, t.accessToken);
    this.storage?.setItem(this.refreshKey, t.refreshToken);

    if (t.tokenType) this.storage?.setItem(this.tokenTypeKey, t.tokenType);
    if (t.expiresAt) this.storage?.setItem(this.accessExpKey, t.expiresAt);
    if (t.refreshTokenExpiresAt) this.storage?.setItem(this.refreshExpKey, t.refreshTokenExpiresAt);
  }

  clear() {
    this.storage?.removeItem(this.accessKey);
    this.storage?.removeItem(this.refreshKey);
    this.storage?.removeItem(this.tokenTypeKey);
    this.storage?.removeItem(this.accessExpKey);
    this.storage?.removeItem(this.refreshExpKey);
    this.storage?.removeItem(this.totpChallengeKey);
    this.storage?.removeItem(this.tempTokenKey);
  }
  getAccessExpiresAt(): string | null {
    return this.storage?.getItem(this.accessExpKey) ?? null;
  }

  getRefreshExpiresAt(): string | null {
    return this.storage?.getItem(this.refreshExpKey) ?? null;
  }
  
  hasTokens(): boolean {
    return !!this.getAccessToken() && !!this.getRefreshToken();
  }
}
